import styled from 'styled-components';

export const AdContainer = styled.div`
  width: 100%;

  margin-top: ${({ theme }) => theme.core.sizing[5]}px;

  > div {
    display: block;
    width: 100%;
    max-width: 100%;
    height: auto;

    margin: auto;

    padding: ${({ theme }) => theme.core.sizing[4]}px;
  }

  @media ${({ theme }) => `${theme.core.breakpoints.s}`} {
    > div {
      max-width: 70%;

      padding: 0;
    }
  }
`;
